'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './vendor-list.routes';

export class VendorListComponent {

  constructor(Auth, $uibModal, BusinessService, DTOptionsBuilder, dialogs, $state, $timeout, Config) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    let DirectoryConfig = Config.getModuleConfig(Config.Modules.Directories);

    this.navStyle = DirectoryConfig.getVendorNavStyle();
    this.categories = DirectoryConfig.getVendorCategories();
    this.selectType = DirectoryConfig.getVendorSelectType();
    this.info = DirectoryConfig.getVendorInfo();

    this.$uibModal = $uibModal;
    this.dialogs = dialogs;
    this.$timeout = $timeout;
    this.$state = $state;

    this.BusinessService = BusinessService;

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, "Preferred Vendor List");

    this.isAdmin = Auth.isAdminSync;

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('order', [0, 'desc'])
      .withOption('buttons',[{
        extend: 'excel',
        title: this.pageTitle
      },{
        extend: 'csv',
        title: this.pageTitle
      },{
        title: this.pageTitle,
        message: 'As of ' + moment().format("MMMM Do YYYY"),
        extend: 'pdf',
        orientation: 'portrait',
        pageSize: 'LETTER'
      },'print']);

    this.loadData();
  }

  loadData() {
    this.BusinessService.queryVendors(data => {
      this.data = data;

      this.categoriesDropdown = [{cat: '', name: 'All (' + this.data.length + ')'}];
      this.categories.forEach(cat => {
        this.categoriesDropdown.push({
          cat: cat,
          name: cat + ' (' + this.getCount(cat) + ')'
        });
      });

      if (this.currentFilterCat) {
        this.$timeout(() => {
          // Give the datatable some time to update itself
          // After that, set the filter again
          this.setFilter(this.currentFilterCat);
        }, 250);
      }
    }, err => {
      console.log("could not retrieve important numbers from server");
    });
  }

  createNewVendor() {
    var dlg = this.dialogs.confirm(
      "Create new vendor?", "Do you want to add a new vendor?");
    dlg.result.then(() => {
      this.$state.go("vendor-edit");
    }, () => {
      // Cancel
    });
  }

  /*openModal(_importantNumber) {

    var that = this;
    var importantNumber = {};

    if (!_importantNumber) {
      importantNumber = {
        name: '',
        number: '',
        category: this.currentFilterCat || this.categories[0]
      }
    } else {
      importantNumber = {
        name: _importantNumber.name,
        number: _importantNumber.number,
        category: _importantNumber.category,
        _id: _importantNumber._id
      }
    }

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'importantNumberEdit',
      resolve: {
        importantNumber: function () {
          return importantNumber;
        },
        config: function () {
          return {}
        }
      }
    });

    modalInstance.result.then(
      function (result) {

        if (result._id) {
          that.ImportantNumberService.upsert({id: result._id}, result, () => {
            that.loadData();
          });
        } else {
          that.ImportantNumberService.save(result, createdNumber => {
            that.loadData();
          });
        }

      },
      function () {
      }
    );
  }
  */

  getCount(cat) {
    if (!this.data) 
      return 0;

    return this.data.reduce((acc, obj) => {
      return acc + (obj.vendorCategory === cat);
    }, 0);
  }

  delete(vendor) {
    var that = this;

    var numText = "<br/><br/><b>" + vendor.name + "</b>";

    var dlg = this.dialogs.confirm("Delete Vendor?", "Do you really want to delete this vendor?" + numText);
    dlg.result.then(() => {
      // OK delete it
      that.BusinessService.delete({id: vendor._id},
        () => {
          that.loadData();
        },
        err => {
          alert("Could not delete vendor");
        });
    }, () => {
      // Cancel
    });
  }

  setFilter(cat) {
    this.currentFilterCat = cat;
    jQuery("table.dataTable").DataTable().columns(1).search(cat).draw();
  }

}

export default angular.module('conduuApp.vendorList', [uiRouter])
  .config(routes)
  .component('vendorList', {
    template: require('./vendor-list.html'),
    controller: VendorListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/directories/vendor/vendor-list.component.js